export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40fbf365e07424fa5d4a110f06742ac723f0471db8&name=revalidateCommunity!'